import React, { useContext } from "react";
import styled from "@emotion/styled";

import DropDown from "../Filters/DropDown";
import SelectedFilters from "../Filters/SelectedFilters";

//style rules
import { Typography, Sizes } from "../../styles";
import Context from "./MediaCentreContext";

const MediaCentreFilters = () => {
	const {
		data: { filters, selectedFilters },
		actions: { handleFilterSelect, clearAllFilters },
	} = useContext(Context);

	const renderDropDowns = () => {
		if (filters.length === 0) return;

		return filters.map((dropDown) => {
			return (
				<DropDown
					key={dropDown.slug}
					filterKey={dropDown.slug}
					dropDownFilters={dropDown.filters}
					DropDownLabel={dropDown.title}
					selectedFilters={selectedFilters}
					handleFilterSelect={handleFilterSelect}
				/>
			);
		});
	};

	const renderSelectedFilters = () => {
		if (selectedFilters.length === 0) return;

		return (
			<SelectedFilters
				selectedFilters={selectedFilters}
				clearAllFilters={clearAllFilters}
				handleFilterSelect={handleFilterSelect}
			/>
		);
	};

	return (
		<Container>
			<p>Filters</p>
			<FiltersContainer>{renderDropDowns()}</FiltersContainer>
			{renderSelectedFilters()}
		</Container>
	);
};

export default MediaCentreFilters;

const Container = styled.div`
	padding-top: 4rem;

	p {
		font-weight: ${Typography.fontWeight.demiBold};
		font-size: 1.4rem;
		line-height: 1.7rem;
		text-transform: uppercase;
	}
`;

// the width of the drop down gets decided here
// we know that each dorpdown needs to have a width of 216px so we time that by number of dropdowns
const FiltersContainer = styled.div`
	padding-top: 1.8rem;
	display: flex;
	flex-direction: column;
	gap: 2.4rem;
	max-width: 604px;

	@media only screen and (min-width: ${Sizes.screens.medium}) {
		align-items: center;
		flex-direction: row;
	}
`;
